import {
  collection,
  getDocs,
  query,
  limit,
  orderBy,
  OrderByDirection,
} from 'firebase/firestore';
import Failure from '../../../core/Failure';
import { FirestoreCollections, firestore } from '../../../firebase.config';

import Subscription from '../../models/Subscription';

async function getSubscriptionsOrderedBy(
  name: string,
  sort: OrderByDirection,
  offset: number,
): Promise<{
  subscriptions: Subscription[];
}> {
  try {
    const db = firestore;
    const subscriptionsCollection = collection(
      db,
      FirestoreCollections.subscriptions
    );

    const results = await getDocs(
      query(
        subscriptionsCollection,
        orderBy(name, sort),
        limit(offset)
      )
    );

    const subscriptions: Subscription[] = [];

    results.docs.forEach((doc) => {
      subscriptions.push(Subscription.fromFirestore(doc));
    });

    return {
      subscriptions
    };
  } catch (e) {
    console.log('error: ', e);
    throw new GetSubscriptionsOrderedByFailure();
  }
}

export class GetSubscriptionsOrderedByFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default getSubscriptionsOrderedBy;
